// client/src/utils/clarity.js
// =============================================================================
// Microsoft Clarity — 點擊 / 滑動熱區圖 + 操作錄影（Phase 2-B）
// -----------------------------------------------------------------------------
// 與 GA4(analytics.js) 同一套設計：
//  1. Project ID：優先讀 env REACT_APP_CLARITY_PROJECT_ID，沒設則用下方 FALLBACK_ID（trade. 正式專案）。
//  2. 只有 ENABLED_HOSTS 內的網域才載入（預設 trade.masquant.com）；localhost / test 不送，
//     所以本機看不到 Clarity 是正常的（不污染正式數據）。
//  3. 動態注入官方 tag script；自帶防重，可重複呼叫。
//
// ⚠️ 隱私：Clarity 會把（Clarity 預設會遮罩文字 / 輸入）的使用者操作送到 Microsoft。
//    視法遵需求加 cookie 同意 / 更新隱私政策——與 GA4 相同的「資料外送第三方」考量。
//
// 啟用步驟：clarity.microsoft.com 建 Project 拿 10 碼 ID → 設 REACT_APP_CLARITY_PROJECT_ID → npm run build。
// =============================================================================

const FALLBACK_ID = "xtwsb3dyxt"; // trade.masquant.com 正式 Clarity 專案（公開 ID，同 GA 做法寫死 source）

export const CLARITY_PROJECT_ID =
  process.env.REACT_APP_CLARITY_PROJECT_ID || FALLBACK_ID;

// 允許載入 Clarity 的正式網域（逗號分隔，可用環境變數覆蓋）
const ENABLED_HOSTS = (process.env.REACT_APP_CLARITY_ENABLED_HOSTS || "trade.masquant.com")
  .split(",")
  .map((h) => h.trim())
  .filter(Boolean);

const currentHost = typeof window !== "undefined" ? window.location.hostname : "";

// 啟用條件：有 Project ID + 目前網域在白名單內
export const isClarityEnabled = !!CLARITY_PROJECT_ID && ENABLED_HOSTS.includes(currentHost);

let initialized = false;

/**
 * 啟動 Microsoft Clarity：動態注入官方 tag。
 * 只在「有設 Project ID + 正式網域」時執行；自帶防重。
 */
export function initClarity() {
  if (initialized || !isClarityEnabled) return;
  initialized = true;

  // 官方 Clarity 載入片段（改寫成函式；window.clarity 為佇列函式）
  (function (c, l, a, r, i) {
    c[a] = c[a] || function () {
      (c[a].q = c[a].q || []).push(arguments);
    };
    const t = l.createElement(r);
    t.async = 1;
    t.src = "https://www.clarity.ms/tag/" + i;
    const y = l.getElementsByTagName(r)[0];
    y.parentNode.insertBefore(t, y);
  })(window, document, "clarity", "script", CLARITY_PROJECT_ID);
}
